import React from 'react'
import { Row } from 'antd'
import { CustomCol } from 'src/components'
import { useTranslation } from 'next-i18next'
import DownLabelItem from './DownLabelItem/DownLabelItem'
import { Location, Users, Compensated, Projects } from 'src/assets/images'

const AuthDownLabels: React.FC = () => {
  const { t } = useTranslation()

  const items = [
    { icon: Location, label1: t('500+'), label2: t('Auth.Main.Companies') },
    { icon: Users, label1: t('2.7k+'), label2: t('Auth.Main.Users') },
    { icon: Compensated, label1: t('3M+'), label2: t('Auth.Main.Tons') },
    { icon: Projects, label1: t('60+'), label2: t('Auth.Main.Projects'), label3: t('Auth.Main.Companies') },
  ]

  return (
    <Row>
      {items.map((item, idx) => (
        <CustomCol lg={6} className='centered-div' key={idx}>
          <DownLabelItem {...item}/>
        </CustomCol>
      ))}
    </Row>
  )
}

export default AuthDownLabels
